export default __webpack_public_path__ + "static/media/Honored Boots of the Golden Horde.07a7d9a8.jpg";